import React from 'react';
import { Column } from 'primereact/column'

/**
 * Edit Action Column - renders row editor buttons (edit, save, cancel)
 * Styled with borderRight: none to visually merge with adjacent ActionsColumn
 *
 * @returns {JSX.Element} Column component
 */
const EditActionColumn = () => {

    const style = {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        borderRight: 'none',
        marginTop: '5px',
        height: '55px'
    }

    return (<Column
        header="Actions"
        rowEditor={rowData => !rowData.isDeleted}
        bodyStyle={style} />)

}


export default EditActionColumn